import type { FaireProductEntity } from "../../entity_types/product";

export const p_etqxwpk25b: FaireProductEntity = {
  token: "p_etqxwpk25b",
  type: "product",
  name: "EUCALYPTUS STEAM® Cleansing Vapors for the Shower® Mini Jar - No Tox Life",
  brandToken: "b_e947fdec",
  brandName: "No Tox Life",
  imageUrl:
    "https://cdn.faire.com/fastly/d13fd20b6a3d70e054f80d4f6dfe9569ac7af2c06751ffac4f37ee109ab62fae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e74c40a0de7645eb29e5a4ac6c73a455864cb5a2b7b77c35b2f4c11ea845bbd.jpeg",
    "https://cdn.faire.com/fastly/cded8cfe2372c3f5083cbcfe088766f44c35f04eb4ab0e2ffdc167953bcf6ff6.jpeg",
    "https://cdn.faire.com/fastly/b91dd95dea46fb8901af3f98d97adc2f2fe20bb6edc35b3296930c3ff14d78ae.jpeg",
    "https://cdn.faire.com/fastly/d59bbac9f13a45db867d55d76522f09d5ec6987db29813fac85757c4d5112b27.jpeg",
    "https://cdn.faire.com/fastly/8d47b347a6f06594ceb87b83c9f0d06df8c32cb7bbb9b7561d8aadf1fcdd62e7.jpeg",
    "https://cdn.faire.com/fastly/ef8c504efbcc4f3e8a48ebd7548ff1eb1be9db6dd3e80c1ed40b2736424d762b.jpeg",
    "https://cdn.faire.com/fastly/5ce8ea9444c7df215e2adf5ea48869b63da486e58dc7cd9b616742406c181aeb.jpeg",
  ],
  priceDollars: 8,
  description:
    "The cleansing vapors of eucalyptus are well known for deep support of respiratory health.\nWith concentrated cooling peppermint to awaken and refresh.\n\n𝐓𝐨 𝐮𝐬𝐞:\nPlace one or two rounds in the shower in the direct stream of water. As the round(s) get wet, they begin to dissolve and release potent essential oils into the hot shower steam. The patent-pending slow-release technology gives you several minutes of refreshing, EUCALYPTUS STEAM® filled air.\n\n4 pcs.\n\nby No Tox Life\n\nEUCALYPTUS STEAM® is a registered trademark of Earth & Daughter LLC\n\nSome occasional broken rounds in transit is normal and will not be refunded as the product is still usable. This is due to our packaging which is free of plastic shrink wrap.\n\nIf you have a problem with excessive breakage of the rounds, please contact us with photos and keep all packaging (box and shipping label) so we can help you out.\n\nRead warnings before use.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:17.442Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
